import { FC, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { AccountResetPassword } from 'pages/Accounts/Accounts.entity';
import { useResetPasswordAccountMutation } from 'pages/Accounts/api/accounts';
import { ChangePasswordForm } from 'pages/Accounts/components';
import { isSuccess } from 'utils/responseStatus';

type Props = {
  id: number;
};

export const ChangePasswordModal: FC<Props> = ({ id }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [resetPasswordAccount, { isLoading }] = useResetPasswordAccountMutation();

  const [form, setForm] = useState<AccountResetPassword>({
    confirmPassword: '',
    password: '',
  });

  const handleChange = (name: keyof AccountResetPassword, value: AccountResetPassword[keyof AccountResetPassword]) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid) return;

    resetPasswordAccount({ ...form, id }).then((data) => {
      if (isSuccess(data)) {
        hideModal();
        toast.success('Пароль успешно изменен', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Смена пароля"
      visible
      isLoadingSubmit={isLoading}
      width={500}
      height="auto"
      textConfirm="Сохранить"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <ChangePasswordForm form={form} onChange={handleChange} />
    </ModalForm>
  );
};
